<template>
    <span class="account-selector-container">
        <div v-if="showDepartments" class="departments-container">
            <div class="departments-list">
                <div v-for="department in filteredDepartments"
                     :key="department.id"
                     @click="selectDepartment(department)"
                     :class="{ 'activeDepartment': department.id === account.department.id }"
                     class="department-item"
                >
                    {{ department.name }}
                </div>
            </div>
        </div>

        <el-dropdown class="item dropdown-min-width" trigger="click" ref="customerDropdown"
                     :hide-on-click="false" @visible-change="handleDropdownVisibleChange">
            <span class="el-dropdown-link" style="color: #ffffff; cursor: pointer;">
                <span v-if="active_account && active_account.hasOwnProperty('department')">
                    {{ active_account.department.title }}
                </span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown">
              <div class="search-container">
                <el-input
                    :placeholder="$t('topbar.search_departments_placeholder')"
                    v-model="query"
                    @click.native.stop=""
                    size="small"
                >
                </el-input>
              </div>

                <div class="customers-scroll-container">
                    <div v-for="customer in filteredCustomers"
                         :key="customer.id"
                         :class="{ 'activeDepartment': customer.id === selectedCustomer.id }"
                         class="customer-item"
                         @click="selectCustomer(customer)"
                    >
                        {{ customer.name }}
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
    </span>
</template>

<script>
import Axios from 'axios';
import handleCookies from '@/mixins/handle-cookies.js';
import Cookies from "js-cookie";

export default {
  props: ['active_account'],

  mixins: [handleCookies],

  data() {
    return {
      search_threshold: 10,
      accounts: [],
      departments: [],
      department_query: '',
      query: '',
      customer_query: '',
      account: JSON.parse(localStorage.getItem('active_account')),
      selected_account: {},
      showDepartments: false,
      selectedCustomer: {},
      customerDepartments: []
    }
  },

  created() {
    this.getAccounts();
    this.selected_account = this.active_account;
    this.selectedCustomer.id = this.account.customer.id
  },

  computed: {
    filteredCustomers() {
      return this.accounts.filter(customer => {
        return customer.name.toLowerCase().includes(this.query.toLowerCase());
      });
    },

    filteredDepartments() {
      return this.departments.filter(account => {
        return account.name.toLowerCase().includes(this.query.toLowerCase());
      });
    }
  },

  methods: {
    async getDepartments(customer) {
      let token = this.$cookies.get('bs_token');
      await Axios.get(`https://api.brandsafe.no/v1/config/all-departments/${customer.id}}`, {headers: {'Authorization': 'Bearer ' + token}}).then((response) => {
        this.departments = response.data;
      }, (error) => {
        this.departments = [];
      });
    },

    getAccounts() {
      let token = this.$cookies.get('bs_token');
      Axios.get('https://api.brandsafe.no/v1/config/sorted-customers', {headers: {'Authorization': 'Bearer ' + token}}).then((response) => {
        this.accounts = response.data;
      }, (error) => {
        this.accounts = [];
      });
    },

    handleDropdownVisibleChange(visible) {
      if (!visible) {
        this.showDepartments = false;
      } else {
      }
    },

    async selectCustomer(customer) {
      await this.getDepartments(customer)
      this.selectedCustomer = customer;

      if (customer.name === "Brandsafe") {
        const brandsafe = this.departments.find(dept => dept.id === 2927);
        await this.selectDepartment(brandsafe)
      } else {
        this.showDepartments = true;
        this.department_query = '';
      }
    },

    async createUserAccountForDepartment(userId, account) {
      const token = this.$cookies.get('bs_token');

      const accountData = {
        customer_id: this.selectedCustomer.id,
        jwt_id: 2,
        department_id: account.department_id || account.id,
        language: this.selectedCustomer.language,
        profile: this.selectedCustomer.profile
      };

      try {
        const response = await Axios.post(
            `https://api.brandsafe.no/v1/config/single-user/${userId}/accounts`,
            accountData,
            {headers: {'Authorization': 'Bearer ' + token}}
        );
        return response.data.account;
      } catch (error) {
        console.log('Account may already exist or could not be created:', error);
        return null;
      }
    },

    async changeUserActiveAccount(accountId) {
      const token = this.$cookies.get('bs_token');

      const response = await Axios.post(
          'https://api.brandsafe.no/v1/profile/accounts',
          {id: accountId},
          {headers: {'Authorization': 'Bearer ' + token}}
      );

      return response.data.data;
    },

    async saveAccountCookies(accountData) {
      const cookies = [
        {key: 'bs_language', value: accountData.language},
        {key: 'bs_role', value: accountData.role.title},
        {key: 'bs_profile', value: accountData.profile},
        {key: 'bs_active_department_id', value: accountData.department.id},
        {key: 'bs_active_customer_id', value: accountData.customer.id}
      ];

      await this.setCookies(cookies);
    },

    async selectDepartment(department) {
      if (department.id === this.active_account.id) {
        this.showDepartments = false;
        return false;
      }

      try {
        const userId = this.$cookies.get('bs_user_id')

        const account = await this.createUserAccountForDepartment(userId, department);

        const accountData = await this.changeUserActiveAccount(account.uuid);

        await this.saveAccountCookies(accountData);

        this.showDepartments = false;

        this.$nextTick(() => {
          location.reload();
        });
      } catch (error) {
        console.error('Error while changing department:', error);
        alert('could_not_change_department');
        this.showDepartments = false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
.account-selector-container {
  position: relative;
  display: inline-block;
}

.dropdown-min-width {
  min-width: 200px;
}

.search-container {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.el-dropdown-menu {
  max-height: none !important;
  min-width: 250px !important;
  padding: 0 !important;
}

.customers-scroll-container {
  max-height: 70vh;
  min-height: 150px;
  overflow-y: auto;
}

.departments-container {
  position: absolute;
  top: 90px;
  right: 265px;
  width: 250px;
  max-height: 800px;
  min-height: 100px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  z-index: 2001;
  margin-right: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.departments-header {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  font-weight: bold;
  color: #333;
}

.departments-header i {
  cursor: pointer;
  color: #909399;
}

.department-search {
  padding: 10px;
}

.departments-list {
  overflow-y: auto;
  max-height: 500px;
}

.department-item {
  padding: 10px 15px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #ebeef5;
}

.department-item:hover {
  background-color: #eceef1;
}

.customer-item {
  list-style: none;
  line-height: 40px;
  padding: 0 20px;
  margin: 0;
  font-size: 16px;
  color: #404244;
  cursor: pointer;
  outline: none;
}

.customer-item:hover {
  background-color: #eceef1;
}

.customer-item.activeDepartment:hover {
  background-color: #e3f1c9;
}

.department-item.activeDepartment:hover {
  background-color: #e3f1c9;
}


</style>